// pages/LandingPage.js
import React from "react";
import Header from "../../components/header";
import Skills from "../../components/skills";
import HeroSection from "../../components/landingpage/HeroSection";
// import AboutUs from "../../components/landingpage/AboutUs";
import Services from "../../components/landingpage/Services";
import Portfolio from "../../components/landingpage/Portfolio";
import Testimonials from "../../components/landingpage/Testimonials";
import ContactUs from "../../components/landingpage/ContactUs";
import FAQ from "../../components/landingpage/FAQ";

const LandingPage = () => {
  return (
    <div style={{ width: "100vw", overflowX: "hidden" }}>
      <Header />

      <div style={{ paddingTop: "70px", width: "100vw", overflowX: "hidden" }}>
        <HeroSection />
        <Skills />
        {/* <div id="services"><Services /></div>
        <div id="portfolio"><Portfolio /></div>
        <Testimonials />
        <ContactUs />
        <FAQ /> */}
      </div>
    </div>
  );
};

export default LandingPage;
